import { Box, createTheme, Grid, ThemeProvider } from "@mui/material";
import ReceiptHeader from "components/Form/ReceiptHeader";

const theme = createTheme({
  typography: {
    fontFamily: "Sarabun, sans-serif",
    fontSize: 10,
    h6: {
      fontSize: 16,
      fontWeight: "bold",
    },
  },
});

const InvoicePreview = ({ data, date = [] }) => {
  return (
    <ThemeProvider
      theme={theme}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        backgroundColor: "#f0f0f0",
      }}
    >
      <Box
        sx={{
          p: 3,
          backgroundColor: "white",
          borderRadius: 2,
          boxShadow: 3,
          height: "599px",
          width: "794px",
          position: "relative",
        }}
      >
        <ReceiptHeader label="ใบขายฝาก" data={data} date={date} />
      </Box>
    </ThemeProvider>
  );
};
export default InvoicePreview;
